import { useAliveController } from '@umijs/max';
import { useState, useCallback, useEffect } from 'react';
import { TabType } from '@/typing.d';

export default () => {
    const [tabs, setTabs] = useState<TabType[]>([]);
    const { dropScope } = useAliveController();
    const [isInit, setIsInit] = useState(true);

    if (isInit) {
        const sessionPageTabs = sessionStorage.getItem('pageTabs') || '';
        const pageTabs =
            sessionPageTabs && JSON.parse(decodeURIComponent(sessionPageTabs));
        if (Array.isArray(pageTabs) && pageTabs.length) {
            let handlePageTabs: any = [];
            pageTabs.forEach((item: any) => {
                handlePageTabs.push({ ...item, alive: false });
            });
            setTabs(handlePageTabs);
        }
        setIsInit(false);
    }
    useEffect(() => {
        if (!isInit) {
            sessionStorage.setItem(
                'pageTabs',
                encodeURIComponent(JSON.stringify(tabs)),
            );
        }
    }, [tabs]);

    // 添加一个标签
    const addTabs = useCallback((tab: TabType) => {
        // if (tab.path.indexOf('/workOrderDetail/') > -1) {
        //     setTabs((items) => {
        //         const index = items.findIndex((item) => item.path === tab.path);
        //         if (index === -1) {
        //             return [...items, tab];
        //         }
        //         return items;
        //     });
        // } else {

        setTabs((items) => {
            const index = items.findIndex((item) => item.path === tab.path);
            const handleItem = [...items];
            if (index === -1) {
                return [...items, tab];
            } else {
                handleItem.splice(index, 1, tab);
            }
            return handleItem;
        });
        // }
    }, []);

    // 编辑标签
    const editTabs = useCallback((index: number, tab: TabType) => {
        setTabs((items) => {
            // const delTab = items[index];
            // console.log(delTab, getCachingNodes());
            // 移除被更新的缓存
            // if (delTab?.alive) {
            //     dropScope(delTab.path);
            // }

            const handleItem = [...items];
            if (index === -1) {
                return [...items, tab];
            } else {
                handleItem.splice(index, 1, tab);
            }
            return handleItem;
        });
    }, []);

    // 移除一个标签
    const removeTabs = useCallback((tab: TabType) => {
        console.log(tab);
        setTabs((items) => {
            return items.filter((item) => item.path !== tab.path);
        });
        // 移除缓存
        if (tab.alive) {
            dropScope(tab.path);
        }
    }, []);

    // 移除全部标签
    const removeAllTabs = useCallback(() => {
        setTabs((items) => {
            items.forEach((item) => {
                // 移除缓存
                if (item.alive) {
                    dropScope(item.path);
                }
            });
            return [];
        });
    }, []);

    return {
        tabs,
        setTabs,
        addTabs,
        editTabs,
        removeTabs,
        removeAllTabs,
    };
};
